import React, { useEffect, useState } from 'react';

import fiscalizacao_api from '../../../../api/fiscalizacao_api';

// Components
import AutoDeFiscalizacao from '../../AutoDeFiscalizacao';
import AvisoItemSemConteudo from './AvisoItemSemConteudo';

const TITULO = "Ficha do Auto de Fiscalização";

export default function ItemFichaFiscalizacao({ hashFiscalizacao, onReady }) {
    const [fiscalizacao, setFiscalizacao] = useState(null);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        if (!hashFiscalizacao) {
            setErro("Esta infração não tem fiscalização vinculada.");
            onReady();
            return;
        }

        fiscalizacao_api.GetFiscalizacaoHash(hashFiscalizacao)
            .then(({ data }) => setFiscalizacao(data))
            .catch(error => setErro(error?.message ?? "Não foi possível carregar a Ficha do Auto de Fiscalização."))
            .finally(onReady);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hashFiscalizacao]);

    if (erro) return <AvisoItemSemConteudo titulo={TITULO} mensagem={erro} />;

    if (!fiscalizacao) return null;
    return <AutoDeFiscalizacao fichaExterna={fiscalizacao} hiddenButtonImprimir />;
}
